import classNames from 'classnames'
import { useTranslation } from 'next-i18next'
import { RefObject, useRef } from 'react'

import InfluencerDetails from '@src/quince-site-common/src/domains/InfluencerDetails'
import Product from '@src/quince-site-common/src/domains/Product'
import ProductTag from '@src/quince-site-common/src/domains/ProductTag'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import { useBatchedAnalyticsCaptureForProductCard } from '@src/quince-site-common/src/hooks/useBatchedAnalyticsCaptureForProductCard'
import useDeviceInfo from '@src/quince-site-common/src/hooks/useDeviceInfo'
import useIsVisible from '@src/quince-site-common/src/hooks/useIsVisible'
import getMaxWidthInPx from '@src/quince-site-common/src/utils/getMaxWidthInPx'

import Image from '../image'

import styles from './influencerCard.module.scss'
export interface InfluencerCardProductDetails {
  product: Product
  selectedOptions: ProductVariantOption[]
  productTags: ProductTag[]
}

interface InfluencerCardProps {
  influencerDetails: InfluencerDetails
  className?: string
  onClick: () => void
  productViewTracker?: string
  productDetails?: InfluencerCardProductDetails
}

const InfluencerCard = ({
  influencerDetails,
  className = '',
  onClick,
  productViewTracker,
  productDetails,
}: InfluencerCardProps) => {
  const { t } = useTranslation('common')
  const classes = classNames(styles.wrapper, className)
  const deviceInfo = useDeviceInfo()
  const maxWidth = getMaxWidthInPx({
    maxWidthDesktopInRem: styles.productImageWidth,
    maxWidthMobileInRem: styles.productImageWidthMobile,
    deviceType: deviceInfo.deviceType,
  })

  const wrapperRef: RefObject<HTMLDivElement> = useRef(null)
  const { isVisible } = useIsVisible(wrapperRef)
  useBatchedAnalyticsCaptureForProductCard({
    applicableTags: productDetails?.productTags,
    isVisible,
    product: productDetails?.product,
    productViewTracker: productViewTracker,
    selectedOptions: productDetails?.selectedOptions,
    wrapperRef,
  })

  return (
    <div className={classes} ref={wrapperRef}>
      <Image
        title={influencerDetails.handler ?? ''}
        url={influencerDetails.images[0]?.url || ''}
        className={styles.image}
        maxWidth={maxWidth}
        // @i18n-ignore
        loading={'lazy'}
        alt=""
      />
      <div className={styles.contentWrapper}>
        {influencerDetails.handler && (
          <div className={styles.handler}>{t('var1', { var1: influencerDetails.handler })}</div>
        )}
        <button className={classNames('text-decor--underline', styles.cta)} onClick={onClick}>
          {t('buy_it_now')}
        </button>
      </div>
    </div>
  )
}

export default InfluencerCard
